customElements.get("recipient-form") ||
    customElements.define(
        "recipient-form",
        class extends HTMLElement {
            constructor() {
                super();
                this.cartUpdateUnsubscriber = void 0;
                this.variantChangeUnsubscriber = void 0;
                this.cartErrorUnsubscriber = void 0;
            }

            connectedCallback() {
                this.recipientFieldsLiveRegion = this.querySelector("#Recipient-fields-live-region-" + this.dataset.sectionId);
                this.checkboxInput = this.querySelector("#Recipient-checkbox-" + this.dataset.sectionId);
                this.checkboxInput.disabled = false;
                this.hiddenControlField = this.querySelector("#Recipient-control-" + this.dataset.sectionId);
                if (this.hiddenControlField) this.hiddenControlField.disabled = true;
                this.emailInput = this.querySelector("#Recipient-email-" + this.dataset.sectionId);
                this.nameInput = this.querySelector("#Recipient-name-" + this.dataset.sectionId);
                this.messageInput = this.querySelector("#Recipient-message-" + this.dataset.sectionId);
                this.sendonInput = this.querySelector("#Recipient-send-on-" + this.dataset.sectionId);
                this.offsetProperty = this.querySelector("#Recipient-timezone-offset-" + this.dataset.sectionId);
                if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();
                this.errorMessageWrapper = this.querySelector(".product-form__recipient-error-message-wrapper");
                this.errorMessageList = this.errorMessageWrapper ? this.errorMessageWrapper.querySelector("ul") : null;
                this.errorMessage = this.errorMessageWrapper ? this.errorMessageWrapper.querySelector(".error-message") : null;
                this.defaultErrorHeader = this.errorMessage ? this.errorMessage.innerText : "";
                this.currentProductVariantId = this.dataset.productVariantId;

                this.addEventListener("change", this.onChange.bind(this));

                if (typeof subscribe !== "undefined") {
                    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, function(e) {
                        if ("product-form" === e.source && e.productVariantId.toString() === this.currentProductVariantId) {
                            this.resetRecipientForm();
                        }
                    }.bind(this));
                    this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, function(e) {
                        if (e.data.sectionId === this.dataset.sectionId) {
                            this.currentProductVariantId = e.data.variant.id.toString();
                        }
                    }.bind(this));
                    this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, function(e) {
                        if ("product-form" === e.source && e.productVariantId.toString() === this.currentProductVariantId) {
                            this.displayErrorMessage(e.message, e.errors);
                        }
                    }.bind(this));
                }

                this.onChange();
            }

            disconnectedCallback() {
                if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
                if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
                if (this.cartErrorUnsubscriber) this.cartErrorUnsubscriber();
            }

            onChange() {
                if (this.checkboxInput.checked) {
                    if (this.hiddenControlField) this.hiddenControlField.disabled = false;
                    this.toggleAddToCart();
                    this.toggleActiveClass();
                    this.enableInputFields();
                    this.recipientFieldsLiveRegion.innerText =
                        window.accessibilityStrings && window.accessibilityStrings.recipientFormExpanded
                            ? window.accessibilityStrings.recipientFormExpanded
                            : "Gift card recipient form expanded";
                } else {
                    if (this.hiddenControlField) this.hiddenControlField.disabled = true;
                    this.toggleAddToCart();
                    this.toggleActiveClass();
                    this.clearInputFields();
                    this.disableInputFields();
                    this.clearErrorMessage();
                    this.recipientFieldsLiveRegion.innerText =
                        window.accessibilityStrings && window.accessibilityStrings.recipientFormCollapsed
                            ? window.accessibilityStrings.recipientFormCollapsed
                            : "Gift card recipient form collapsed";
                }
            }

            inputFields() {
                return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
            }

            disableableFields() {
                return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput, this.offsetProperty];
            }

            clearInputFields() {
                this.inputFields().forEach(function(e) { e.value = ""; });
            }

            enableInputFields() {
                this.disableableFields().forEach(function(e) { e.disabled = false; });
                this.emailInput.required = true;
            }

            disableInputFields() {
                this.disableableFields().forEach(function(e) { e.disabled = true; });
                this.emailInput.required = false;
            }

            toggleActiveClass() {
                if (this.checkboxInput.checked) {
                    this.classList.add("active");
                } else {
                    this.classList.remove("active");
                }
            }
            toggleAddToCart() {
                var standardForm = document.querySelector(".product-form--form:not(.product-form--form--gift)");
                var giftForm = document.querySelector(".product-form--form--gift");
                if (this.checkboxInput.checked) {
                    if (standardForm) standardForm.style.display = "none";
                    if (giftForm) giftForm.style.display = "flex";
                } else {
                    if (standardForm) standardForm.style.display = "flex";
                    if (giftForm) giftForm.style.display = "none";
                }
            }

            displayErrorMessage(e, t) {
                this.clearErrorMessage();
                this.errorMessageWrapper.hidden = false;
                if ("object" == typeof t) {
                    this.errorMessage.innerText = this.defaultErrorHeader;
                    Object.entries(t).forEach(function(entry) {
                        var key = entry[0];
                        var val = entry[1];
                        var r = "RecipientForm-" + key + "-error-" + this.dataset.sectionId;
                        var s = "#Recipient-" + key + "-" + this.dataset.sectionId;
                        var errText = val.join(", ");
                        var i = this.querySelector("#" + r);
                        var a = i ? i.querySelector(".error-message") : null;
                        if (a) {
                            if (this.errorMessageList) {
                                this.errorMessageList.appendChild(this.createErrorListItem(s, errText));
                            }
                            a.innerText = errText + ".";
                            i.classList.remove("hidden");
                            var input = this[key + "Input"];
                            if (input) {
                                input.setAttribute("aria-invalid", true);
                                input.setAttribute("aria-describedby", r);
                            }
                        }
                    }.bind(this));
                } else {
                    this.errorMessage.innerText = t;
                }
            }

            createErrorListItem(e, t) {
                var r = document.createElement("li");
                var s = document.createElement("a");
                s.setAttribute("href", e);
                s.innerText = t;
                r.appendChild(s);
                r.className = "error-message";
                return r;
            }

            clearErrorMessage() {
                this.errorMessageWrapper.hidden = true;
                if (this.errorMessageList) this.errorMessageList.innerHTML = "";
                this.querySelectorAll(".recipient-fields .form__message").forEach(function(e) {
                    e.classList.add("hidden");
                    var msg = e.querySelector(".error-message");
                    if (msg) msg.innerText = "";
                });
                [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].forEach(function(e) {
                    e.setAttribute("aria-invalid", false);
                    e.removeAttribute("aria-describedby");
                });
            }

            resetRecipientForm() {
                if (this.checkboxInput.checked) {
                    this.checkboxInput.checked = false;
                    this.clearInputFields();
                    this.clearErrorMessage();
                }
            }
        }
    );

var handleVariantChange = function(e) {
    var variant = e.detail.variant;
    var t = document.getElementById("gift-card-image");
    if (t && variant.featured_image) t.value = "https:" + variant.featured_image.src;
};

document.addEventListener("variant:change", handleVariantChange);

document.querySelectorAll('input[name="send_on_tab"]').forEach(function(e) {
    e.addEventListener("change", function() {
        var cal = document.querySelector(".field__calendar");
        if (cal) cal.style.display = "choose_date" === e.value ? "block" : "none";
    });
});

// Override pdp_atc to handle recipient form properties and visible-button-only label reset
var _original_pdp_atc = pdp_atc;
pdp_atc = function(form) {

    if($(form).hasClass('manual')) {
        return true;
    }

    // pause only the visible ATC button
    $(form).find('[data-pdp-atc]:visible').prop('disabled', true);
    $(form).find('[data-pdp-atc]:visible').text('ADDING...');

    $('[data-atc-mimic]').prop('disabled', true);
    $('[data-atc-mimic] > .active-cta').text('ADDING...');

    var productdata = $(form).serializeObject();
    productdata = Object.entries(productdata).reduce((acc, [key, value]) => {
        const match = key.match(/^properties\[(.+)\]$/); // fixed regex to allow spaces
        if (match) {
            acc.properties = acc.properties || {};
            acc.properties[match[1]] = value;
        } else {
            acc[key] = value;
        }
        return acc;
    }, {});

    if($(form).find('.product-form--qty--input--field').data('multiplier')) {
        productdata.quantity = parseInt(productdata.quantity) * parseInt($(form).find('.product-form--qty--input--field').data('multiplier'));
    }

    var p_atc_source_placement = '';
    var p_atc_source_type = '';
    var p_atc_source_value = '';

    if(productdata.hasOwnProperty('properties')) {
        if(productdata.properties.hasOwnProperty('_atc_source_placement')) {
            p_atc_source_placement = productdata.properties['_atc_source_placement'];
        }
        if(productdata.properties.hasOwnProperty('_atc_source_type')) {
            p_atc_source_type = productdata.properties['_atc_source_type'];
        }
        if(productdata.properties.hasOwnProperty('_atc_source_value')) {
            p_atc_source_value = productdata.properties['_atc_source_value'];
        }
    }

    var atcdata = { 'items': [] };

    if($(form).find('input[name="addon_paid_pump"]').length > 0) {
        if($(form).find('input[name="addon_paid_pump"]').is(':checked')) {
            var addon_paid_pump_qty_pump = parseInt($(form).find('input[name="addon_paid_pump"]').val());
            var addon_paid_pump_qty_multiplier = parseInt($(form).find('[data-pdp-qty]').val());
            var addon_paid_pump_qty = addon_paid_pump_qty_pump * addon_paid_pump_qty_multiplier;
            atcdata.items.push({
                'id': $(form).find('input[name="addon_paid_pump"]').data('variant-id'),
                'quantity': addon_paid_pump_qty,
                'properties': {
                    '_atc_source_placement': p_atc_source_placement,
                    '_atc_source_type': p_atc_source_type,
                    '_atc_source_value': p_atc_source_value
                }
            });
        }
    }

    if($(form).find('input[name="addon_product"]').length > 0) {
        $(form).find('input[name="addon_product"]').each(function() {
            if($(this).is(':checked')) {
                var addon_product_data = {
                    'id': $(form).find('input[name="addon_product"]').data('variant-id'),
                    'quantity': parseInt($(this).val()),
                    'properties': {
                        '_atc_source_placement': p_atc_source_placement,
                        '_atc_source_type': p_atc_source_type,
                        '_atc_source_value': p_atc_source_value
                    }
                };
                if($(this).data('selling-plan')) {
                    addon_product_data.selling_plan = $(this).data('selling-plan');
                }
                atcdata.items.push(addon_product_data);
            }
        });
    }

    atcdata.items.push(productdata);

    var bsr_sections = false;
    if($(form).find('input[name="bsr"]').length > 0) {
        bsr_sections = $(form).find('input[name="bsr"]').val();
    }

    try {
        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(atcdata)
        })
        .then(function(response) {
            if (!response.ok) {
                return response.json().then(function(errData) { throw errData; });
            }
            return response.json();
        })
        .then(function(r) {
            console.log('AJAX add to cart success.', r);

            if($('#mqg').length > 0) {
                $('[data-pdp-atc]').text('GIFT REDEEMED');
                $('[data-pdp-atc]').prop('disabled', true);
                $('[data-atc-mimic]').find('.active-cta').text('GIFT REDEEMED');
                $('[data-atc-mimic]').find('.active-price').html('<span class="active-pay-price" data-pdp-form-price-actual>' + $('[data-pdp-form-price-compareat]').data('orig') + '</span>');
                $('[data-atc-mimic]').prop('disabled', true);
                $('[data-atc-mimic-link]').html('<span class="pdp-stickycta-button-text">GIFT REDEEMED</span>');
                $('[data-atc-mimic-link]').removeAttr('onclick');
                $('[data-atc-mimic-link]').addClass('disabled');
            }

            var product_id = r.items[0].product_id;
            var new_source_type = r.items[0].properties['_atc_source_type'];
            var new_source_value = r.items[0].properties['_atc_source_value'];
            var new_source_placement = r.items[0].properties['_atc_source_placement'];
            $('.product-id-' + product_id + '[name="properties[_atc_source_type]"]').val(new_source_type);
            $('.product-id-' + product_id + '[name="properties[_atc_source_value]"]').val(new_source_value);
            $('.product-id-' + product_id + '[name="properties[_atc_source_placement]"]').val(new_source_placement);
            $('#product_form_' + product_id).find('[name="properties[_atc_source_placement]"]').addClass('revised');

            if(bsr_sections) { bsr(bsr_sections); }

            window.location.hash = 'cart-open';
            ajaxCart.load();
        })
        .catch(function(err) {
            console.error('Fetch add to cart error:', err);
            var recipientForm = document.querySelector('recipient-form');
            if (recipientForm && err.description) {
                recipientForm.dispatchEvent(new CustomEvent('cart-error', {
                    detail: { message: err.message, errors: err.description }
                }));
            }
        })
        .finally(function() {
            var $atcBtn = $(form).find('[data-pdp-atc]:visible');
            if($atcBtn.data('label-active') == 'subx') {
                $atcBtn.text($atcBtn.data('label-subx'));
                $('[data-atc-mimic] > .active-cta').text($atcBtn.data('label-subx'));
            } else {
                $atcBtn.text($atcBtn.data('label-default'));
                $('[data-atc-mimic] > .active-cta').text($atcBtn.data('label-default'));
            }
            $(form).find('[data-pdp-atc]').prop('disabled', false);
            $('[data-atc-mimic]').prop('disabled', false);
        });

        return false;
    }
    catch(err) {
        console.warn('AJAX execution failed. Submitting manually.');
        console.warn(err);
        return true;
    }
};